import { useSessionStorageWithFallback } from './useSessionStorageWithFallback'

export const useSafeSessionStorage = {
  get(key: string) {
    return useSessionStorageWithFallback.get(key)
  },
  set(key: string, value: string) {
    useSessionStorageWithFallback.set(key, value)
  },
  remove(key: string) {
    useSessionStorageWithFallback.remove(key)
  }
}
